<template>
    <div class="sidebar-detail">
        <detail-header
            v-if="detailInfo"
            :title="`${detailInfo.name || '----' } (${((detailInfo.qrCode||{}).code)})`"
            :isShowBtn="!disableDetailBtn"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        >
        </detail-header>

        <el-tabs v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane :label="$t('detail.Details')" name="details">
                <div v-if="detailInfo">
                    <p class="detail-title">{{$t('detail.Details')}}</p>
                    <div>
                        <table class="recording-detail-table" >
                            <tr>
                                <td>{{$t('detail.Id')}}</td>
                                <td>{{(detailInfo.id) || '-'}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('detail.QRCode')}}</td>
                                <td>{{((detailInfo.qrCode||{}).code) || '-'}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('detail.SubjectStatus')}}</td>
                                <td><span v-html="$_getSubjectStatusUI((detailInfo.subjectStatus||{}).name || '-', (detailInfo.subjectStatus||{}).colour)"></span></td>
                            </tr>
                            <tr>
                                <td>{{$t('detail.SubjectType')}}</td>
                                <td>{{((detailInfo.subjectType||{}).name) || '-'}}</td>
                            </tr>
                            <extension-data-detail :extensionData="detailInfo" extensionDataPath="extensionDataList"></extension-data-detail>
                        </table>
                    </div>

                    <p class="detail-title">{{$t('detail.SubjectOrigin', { subject: (detailInfo.name) || '-' })}}</p>
                    <div>
                        <table class="recording-detail-table" >
                            <tr>
                                <td>{{$t('detail.OriginSubjectType')}}</td>
                                <td>
                                    <div v-if="subjectParents.length > 0">
                                        <div class="parent-hierrachy-container" v-for="(parent, index) in subjectParents" :key="'parent' + index">
                                            <p class="parent-hierrachy-text" @click="$_navigateTo({
                                                name: 'SubjectDetail',
                                                params: { 'subjectId': parent.subjectId } 
                                            })">{{parent.name}} </p>
                                            <span class="parent-hierrachy-symbol" v-if="index != subjectParents.length - 1">&nbsp;> &nbsp;</span>
                                        </div>
                                    </div>
                                    <p v-else class="empty-text"> ------ </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                    
                    <p class="detail-title">{{$t('detail.SubjectStorage', { subject: (detailInfo.name) || '-' })}}</p>
                    <div>
                        <table class="recording-detail-table" >
                            <tr>
                                <td>{{$t('detail.Location')}} </td>
                                <td>
                                    <div v-if="inventoryParents.length > 0">
                                        <div class="parent-hierrachy-container" v-for="(parent, index) in inventoryParents" :key="'parent' + index">
                                            <p class="parent-hierrachy-text" @click="$_navigateTo({
                                                name: 'InventoryDetail',
                                                params: { 'inventoryId': parent.childId } 
                                            })">{{parent.name}} </p>
                                            <span class="parent-hierrachy-symbol" v-if="index != inventoryParents.length - 1">&nbsp;> &nbsp;</span>
                                        </div>
                                    </div>
                                    <p v-else class="empty-text"> ------ </p>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('detail.Amount')}} </td>
                                <td>{{currentAmount}}</td>
                            </tr>
                        </table>
                    </div>

                    <p class="detail-title">{{$t('detail.DateTime')}}</p>
                    <div class="user-datetime-container">
                        <table>
                            <tr>
                                <td>{{$t('detail.Modified')}}</td>
                                <td>{{$_getDateTimeFormat(detailInfo.lastModificationTime)}} {{$t('detail.by')}} {{(detailInfo.lastModifierUser||{}).userName || '-'}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('detail.Created')}}</td>
                                <td>{{$_getDateTimeFormat(detailInfo.creationTime)}} {{$t('detail.by')}} {{(detailInfo.creatorUser||{}).userName || '-'}}</td>
                            </tr>
                        </table>
                    </div>

                    <div class="button-group-container" v-if="!disableDetailBtn">
                        <detail-btn class="detail-btn" :paramId="detailInfo.id" paramName="subjectId" pageName="SubjectDetail" />
                    </div>
                </div>
                <p v-else class="empty-text"> ------ </p>
            </el-tab-pane>

            <el-tab-pane label="Amount History" name="amount_history">
                <amount-history-table :infoSidebarId="infoSidebarId" :currentAmount="currentAmount" v-if="activeName=='amount_history'"></amount-history-table>
            </el-tab-pane>
            
            <el-tab-pane label="Edit History" name="edit_history">
                <changes-history-table :editHistory="editHistory" @handlePageChange="handleEditHistoryPageChange" :editHistoryApiParams="editHistoryApiParams" v-if="activeName=='edit_history'"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import DetailButton from '@/components/Button/DetailButton'
import { compareValues } from '@/utils/sort-value'
import ExtensionDataDetail from '@/components/ExtensionDataDetail'
import { subjectGet, subjectGetChangeHistory, subjectGetAmountChangeHistory } from '@/api/subject'
import DetailHeader from './DetailHeader'
import AmountHistoryTable from './amountHistoryTable'
import ChangesHistoryTable from './changeHistoryTable'

    export default {
        components: {
            'extension-data-detail': ExtensionDataDetail,
            'detail-btn': DetailButton,
            'detail-header': DetailHeader,
            'amount-history-table': AmountHistoryTable,
            'changes-history-table': ChangesHistoryTable,
        },
        props: {
            infoSidebarId: {
                type: Number | String
            },
            disableDetailBtn: {
                type: Boolean,
                default: false
            },
            detailInfomation: {
                type: Object
            }
        },
        data() {
            return {
                activeName: 'details',
                historyRecord: null,
                detailInfo: null,

                editHistory: null,
                editHistoryCurrentPage: 1,
                editHistorySkipCount: 0,
                editHistoryMaxResultCount: 5,
            }
        },
        computed: {
            currentAmount() {
                return `${this.detailInfo?.amount || '-'} (${this.detailInfo.subjectType?.measurementUnit?.name || '-'})`
            },
            editHistoryApiParams(){
                var fix_params = {
                    'SkipCount': this.editHistorySkipCount,
                    'MaxResultCount': this.editHistoryMaxResultCount,
                }
                var params = Object.assign(fix_params);
                return params;
            },
            subjectExtensionData() {
                return this.detailInfo ? this.detailInfo.extensionDataList : [] 
            },
            subjectParents() {
                if(this.detailInfo) {
                    var arry = this.detailInfo.parents ? this.detailInfo.parents : []
                    var nextParent
                    var nextSequence = 1

                    var allChildId = arry.map(arr => arr.childId)
                    arry.forEach(i => {
                        if(!allChildId.includes(i.subjectId)) {
                            i.sequence = nextSequence++
                            nextParent = i
                        }
                    })

                    arry.forEach(i => {
                        arry.forEach(j => {
                            if(j.subjectId == nextParent.childId) {
                                j.sequence = nextSequence++
                                nextParent = j
                            }
                        })
                    })

                    return arry.sort(compareValues('sequence', 'asc'));
                }
            },
            inventoryParents() {
                if(this.detailInfo) {
                    var arry = this.detailInfo.inventoryHierarchy ? this.detailInfo.inventoryHierarchy : []
                    return this.$_arrangeHierarchy(arry)
                }
            }
        },
        methods: {
            async getDetails() {
                if(this.infoSidebarId){
                    var res = await subjectGet({ Id: this.infoSidebarId })
                    if(res) {
                        this.detailInfo = res
                    }
                    
                    if(this.activeName == 'edit_history') this.getSubjectEditHistory()
                }
            },
            refreshDetailPage() {
                this.getDetails()
            },
            closeDetailPage() {
                this.$store.dispatch('info_sidebar/setInfoSidebar');
            },
            downloadImg(url) {
                window.open(url);
            },
            handleEditHistoryPageChange(event) {
                this.editHistorySkipCount = event
                this.getSubjectEditHistory()
            },
            async getSubjectEditHistory() {
                var res = await subjectGetChangeHistory({ 'SubjectId': this.detailInfo.id, 'Sorting': 'creationTime desc', ...this.editHistoryApiParams })
                this.editHistory = res
            },
            handleTabClick(tab, event) {
                if(tab.name == 'edit_history'){
                    this.getSubjectEditHistory()
                }
            },
        },
        watch: {
            infoSidebarId: {
                immediate: true,
                handler(newVal, oldVal) {
                    this.getDetails()
                },
            },
            detailInfomation() {
                return this.detailInfo = this.detailInfomation
            }
        }
    }
</script>

<style lang="css" scoped>
.sidebar-detail p{
    margin: var(--space-8) 0;
}
.sidebar-detail ul li{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
}
.recording-detail-table tr td{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
    padding: var(--space-4) var(--space-8);
    color: var(--charcoal-black)
}

.detail-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-title {
    color: var(--main-color-1);
    font-size: var(--detail-page-title);
}
.empty-text{
    color: var(--charcoal-black);
    padding-left: var(--space-16);
}
.parent-hierrachy-container {
    display: inline-block;
}
.parent-hierrachy-text, .parent-hierrachy-symbol {
    display: inline-block;
    font-size: var(--form-label-size);
    color: var(--main-color-2);
    font-weight: 700;
    cursor: pointer;
}
.parent-hierrachy-text:hover {
    text-decoration: underline;
}
.subject-detail-btn{
    margin: var(--space-4) var(--space-8);
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/SubjectSidebar.vue